import { createContext } from 'react'

export interface AppContextValues {
    sidebar: {
        isOpen: boolean
        setIsOpen: (isOpen: boolean) => void
    }
    // TODO add other properties as we convert more files to ts
    dropdown: {
        isDropdownOpen: boolean
        setDropdownOpen: (isDropdownOpen: boolean) => void
    }
}

export const AppContext = createContext<AppContextValues | undefined>(undefined)
